import React from "react";

import styles from "./DropdownInput.scss";

export type DropdownConrtrolMessagesProps = {
  hintMessage?: string;
  invalidMessage?: string;
  isValid: boolean;
};

const DropdownInputMessages = (
  props: DropdownConrtrolMessagesProps
): JSX.Element => {
  const { hintMessage, invalidMessage, isValid } = props;
  return (
    <>
      {hintMessage && <p className={styles.hint}>{hintMessage}</p>}

      {!isValid && <p className={styles.message}>{invalidMessage}</p>}
    </>
  );
};

export default DropdownInputMessages;
